var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.previewRoute)?_c('div',{staticClass:"static_page_preview_link"},[_c('router-link',{staticClass:"preview_btn",attrs:{"to":_vm.previewRoute}},[_c('i',{staticClass:"fas fa-external-link-alt"}),_vm._v(" "+_vm._s(_vm.$t("STATIC_PAGES.previewPage"))+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }